import React from 'react';
import { cn } from '@/lib/utils';

interface PillProps {
  disabled?: boolean;
}

const Pill = ({ children, className, disabled }: React.BaseHTMLAttributes<HTMLSpanElement> & PillProps) => (
  <span
    className={cn([
      'rounded-[2px] relative -top-[1px] text-[12px] text-center font-bold text-venn-white inline bg-venn-grey-90',
      'py-[1px] px-[5px] mr-[6px]',
      disabled ? 'opacity-20' : '',
      className,
    ])}
  >
    {children}
  </span>
);

export default Pill;
